import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteOrder, getRegistrationForms } from '../../shared/api/user';
import { useState, useEffect } from 'react';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import "./registrations.css";
import { useNavigate } from "react-router-dom";

export default function BasicTable() {
    const navigate = useNavigate();
    const [registrations, setRegistrations] = useState([]);
    //   const [Offset, setOffset] = useState([]);

    const init = async () => {
        let rows = await getRegistrationForms();
        setRegistrations(rows.data.Forms);
        setTimeout(() => {
            console.log(registrations)
        }, 2000)
    }

    useEffect(() => {
        init();
    }, []);

    const navigateToDetails = (id) => {
        navigate(`/details/${id}`);
    }

    //   async function paginationClicked(e) {
    //     setOffset(Number(e.target.innerText * 10))
    //     let rows = await getOrdersList(Offset);
    //     setOrders(rows.data.orders);
    //   }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Phone</TableCell>
                        <TableCell align="right">Email</TableCell>
                        <TableCell align="right">Role</TableCell>
                        <TableCell align="right">Locations</TableCell>
                        <TableCell align="right">Delete</TableCell>
                        <TableCell align="right">Contact Time</TableCell>
                        <TableCell align="right">Details</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {registrations?.map((row) => (
                        <TableRow
                            key={row._id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row?.name}
                            </TableCell>
                            <TableCell align="right">{row?.phoneNumber}</TableCell>
                            <TableCell align="right">{row?.email}</TableCell>
                            <TableCell align="right">{row?.role}</TableCell>
                            <TableCell align="right">{row?.totalLocations}</TableCell>
                            <TableCell align="right"><Button variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
                            <TableCell align="right">{moment(row?.contactDate).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                            <TableCell align="right"><Button onClick={() => navigateToDetails(row._id)} variant="text">View more</Button></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {/* <Stack spacing={3}>
                <Pagination onClick={(event) => paginationClicked(event)} count={10} color="primary" />
            </Stack> */}
        </TableContainer>
    );
}